import { render, staticRenderFns } from "./ContactView.vue?vue&type=template&id=9b6d6002&scoped=true&lang=pug&"
import script from "./ContactView.vue?vue&type=script&lang=js&"
export * from "./ContactView.vue?vue&type=script&lang=js&"
import style0 from "./ContactView.vue?vue&type=style&index=0&id=9b6d6002&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6d6002",
  null
  
)

export default component.exports